import React, { useState } from "react";
import "./AccordionPayroll.css";
import moment from "moment";
import { monthDefaultFormat, todayFormated } from "../../util/formatDate";

const Accordion = ({
  data,
  uangMakanTransport,
  uangBpjs,
  index,
  type,
  filterDate,
  whitelistTanggal,
}) => {
  const bulanBayar = () => {
    if (data.date) {
      const month = moment(data.date).utcOffset("+0700").month() + 1;
      const year = moment(data.date).utcOffset("+0700").year();
      return `${monthDefaultFormat[month]} ${year}`;
    } else {
      const month = moment(data.date).utcOffset("+0700").month() + 1;
      const year = moment(data.date).utcOffset("+0700").year();
      return `${monthDefaultFormat[month]} ${year}`;
    }
  };

  const validateWorkingShiftOne = () => {
    const validateWhiteListTanggal =
      whitelistTanggal &&
      whitelistTanggal.find((o) => o.tanggal === todayFormated);
    if (type === "Payroll") {
      const today = new Date();
      // const whitelistDay = today.getDay();
      const yesterday = new Date(`${data.shiftOneDate} 00:00:00 GMT+0700`);
      today.setDate(today.getDate() - 1);

      if (
        yesterday.toDateString() === today.toDateString() &&
        // whitelistDay !== 7 &&
        validateWhiteListTanggal === undefined
      ) {
        return data.workingShiftOne;
      } else {
        return 0;
      }
    } else if (type === "Riwayat") {
      const today = new Date(filterDate);
      // const whitelistDay = today.getDay();
      const yesterday = new Date(`${data.shiftOneDate} 00:00:00 GMT+0700`);
      today.setDate(today.getDate() - 1);

      if (
        yesterday.toDateString() === today.toDateString() &&
        // whitelistDay !== 7 &&
        validateWhiteListTanggal === undefined
      ) {
        return data.workingShiftOne;
      } else {
        return 0;
      }
    }
  };
  const validateLemburShiftOne = () => {
    if (type === "Payroll" && data && data.lemburLibur > 0) {
      const today = new Date();
      const yesterday = new Date(`${data.shiftOneDate} 00:00:00 GMT+0700`);
      today.setDate(today.getDate() - 1);

      if (yesterday.toDateString() === today.toDateString()) {
        let calculate =
          data && data.lemburLibur - Number(data && data.lemburLiburShiftOne);
        return calculate;
      } else {
        return data.lemburLibur;
      }
    } else if (type === "Riwayat" && data && data.lemburLibur > 0) {
      const today = new Date(filterDate);
      const yesterday = new Date(`${data.shiftOneDate} 00:00:00 GMT+0700`);
      today.setDate(today.getDate() - 1);

      if (yesterday.toDateString() === today.toDateString()) {
        let calculate =
          data && data.lemburLibur - Number(data && data.lemburLiburShiftOne);
        return calculate;
      } else {
        return data.lemburLibur;
      }
    } else {
      return 0;
    }
  };

  const validateWorkingShiftOneProbation = () => {
    const validateWhiteListTanggal =
      whitelistTanggal &&
      whitelistTanggal.find((o) => o.tanggal === todayFormated);
    if (type === "Payroll") {
      const today = new Date();
      // const whitelistDay = today.getDay();
      const yesterday = new Date(`${data.shiftOneDate} 00:00:00 GMT+0700`);
      today.setDate(today.getDate() - 1);

      if (
        yesterday.toDateString() === today.toDateString() &&
        // whitelistDay !== 7 &&
        validateWhiteListTanggal === undefined
      ) {
        return data.workingShiftOneProbation;
      } else {
        return 0;
      }
    } else if (type === "Riwayat") {
      const today = new Date(filterDate);
      // const whitelistDay = today.getDay();
      const yesterday = new Date(`${data.shiftOneDate} 00:00:00 GMT+0700`);
      today.setDate(today.getDate() - 1);

      if (
        yesterday.toDateString() === today.toDateString() &&
        // whitelistDay !== 7 &&
        validateWhiteListTanggal === undefined
      ) {
        return data.workingShiftOneProbation;
      } else {
        return 0;
      }
    }
  };
  const validateLemburShiftOneProbation = () => {
    if (type === "Payroll" && data && data.lemburLiburProbation > 0) {
      const today = new Date();
      const yesterday = new Date(`${data.shiftOneDate} 00:00:00 GMT+0700`);
      today.setDate(today.getDate() - 1);

      if (yesterday.toDateString() === today.toDateString()) {
        let calculate =
          data &&
          data.lemburLiburProbation -
            Number(data && data.lemburLiburProbationShiftOne);
        return calculate;
      } else {
        return data.lemburLiburProbation;
      }
    } else if (type === "Riwayat" && data && data.lemburLiburProbation > 0) {
      const today = new Date(filterDate);
      const yesterday = new Date(`${data.shiftOneDate} 00:00:00 GMT+0700`);
      today.setDate(today.getDate() - 1);

      if (yesterday.toDateString() === today.toDateString()) {
        let calculate =
          data &&
          data.lemburLiburProbation -
            Number(data && data.lemburLiburProbationShiftOne);
        return calculate;
      } else {
        return data.lemburLiburProbation;
      }
    } else {
      return 0;
    }
  };

  const d = new Date(data.date);
  const date = d.getDate();

  const [initialExpand, setInitialExpand] = useState(false);

  const totalWorking = () => {
    if (type === "Payroll") {
      if (data.employeeType === "Permanent") {
        if (data.totalWorking > 730800) {
          return 756000;
        } else {
          return data.totalWorking;
        }
      } else if (data.employeeType === "Contract") {
        if (
          date === 26 &&
          data.totalWorking - validateWorkingShiftOne() > 327600
        ) {
          return 327600;
        } else {
          return data.totalWorking - validateWorkingShiftOne();
        }
      }
    } else if (type === "Riwayat") {
      if (data.employeeType === "Permanent") {
        if (data.totalWorking > 730800) {
          return 756000;
        } else {
          return data.totalWorking;
        }
      } else if (data.employeeType === "Contract") {
        if (
          date === 26 &&
          data.totalWorking - validateWorkingShiftOne() > 327600
        ) {
          return 327600;
        } else {
          return data.totalWorking - validateWorkingShiftOne();
        }
      } else {
        return data.totalWorking - validateWorkingShiftOne();
      }
    }
  };

  const totalWorkingProbation = () => {
    if (type === "Payroll") {
      if (data.employeeType === "Permanent") {
        if (data.totalWorkingProbation > 730800) {
          return 756000;
        } else {
          return data.totalWorkingProbation;
        }
      } else if (data.employeeType === "Contract") {
        if (
          date === 26 &&
          data.totalWorkingProbation - validateWorkingShiftOneProbation() >
            352800
        ) {
          return 352800;
        } else {
          return (
            data.totalWorkingProbation - validateWorkingShiftOneProbation()
          );
        }
      }
    } else if (type === "Riwayat") {
      if (data.employeeType === "Permanent") {
        if (data.totalWorkingProbation > 730800) {
          return 756000;
        } else {
          return data.totalWorkingProbation;
        }
      } else if (data.employeeType === "Contract") {
        if (
          date === 26 &&
          data.totalWorkingProbation - validateWorkingShiftOneProbation() >
            352800
        ) {
          return 352800;
        } else {
          return (
            data.totalWorkingProbation - validateWorkingShiftOneProbation()
          );
        }
      } else {
        return data.totalWorkingProbation - validateWorkingShiftOneProbation();
      }
    }
  };

  const basicSallary = data.basicSallary;
  const basicSallaryProbation = data.basicSallaryProbation;
  const daySallary = data.basicSallary / 30;
  const daySallaryProbation = data.basicSallaryProbation
    ? data.basicSallaryProbation / 30
    : 0;
  const halfDaySallary =
    data.employeeType === "Permanent" &&
    data.setengahHari > 0 &&
    data.setengahHari / 3600 < 7
      ? data.setengahHari / 3600 - 7
      : data.employeeType === "Permanent" && data.setengahHari / 3600 >= 7
      ? data.setengahHari / 3600 - 14
      : data.setengahHari / 3600;

  const tidakMasuk = data.tidakMasuk ? data.tidakMasuk : 0;
  const shiftOne = data.shiftSatu;
  const lemburLibur = validateLemburShiftOne();
  const lemburLiburProbation = validateLemburShiftOneProbation();
  const lembur = data.totalOT;
  const jamOTLibur = data.jamOTLibur ? data.jamOTLibur : 0;
  const displayJamOT = data.jamOT ? data.jamOT : 0;
  const uangTransport = () => {
    if (type === "Riwayat") {
      return data.uangTransport;
    } else {
      if (data.employeeType === "Permanent") {
        return data.uangTransport;
      } else if (data.employeeType === "Contract" && uangMakanTransport) {
        return data.uangTransport;
      } else {
        return 0;
      }
    }
  };

  const uangMakan = () => {
    if (type === "Riwayat") {
      return data.uangMakan;
    } else {
      if (data.employeeType === "Permanent") {
        return data.uangMakan;
      } else if (data.employeeType === "Contract" && uangMakanTransport) {
        return data.uangMakan;
      } else {
        return 0;
      }
    }
  };
  const kurangBayar = data.kurangBayar;
  const lebihBayar = data.lebihBayar;
  const bpjsTK = () => {
    if (type === "Riwayat") {
      return data.bpjsTK;
    } else {
      if (data.employeeType === "Permanent") {
        return data.bpjsTK;
      } else if (data.employeeType === "Contract" && uangBpjs) {
        return data.bpjsTK;
      } else {
        return 0;
      }
    }
  };
  const bpjsK = () => {
    if (type === "Riwayat") {
      return data.bpjsK;
    } else {
      if (data.employeeType === "Permanent") {
        return data.bpjsK;
      } else if (data.employeeType === "Contract" && uangBpjs) {
        return data.bpjsK;
      } else {
        return 0;
      }
    }
  };
  const kasbon = data.kasbon;

  const waktuCicilan = data.waktuCicilan;

  const formatDot = (value) => {
    return value && value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  };

  const potonganTidakMasuk = (tidakMasuk / 7) * daySallary;

  const totalGaji =
    data.employeeType === "Permanent"
      ? data.type === "history_contract"
        ? 0
        : basicSallary
      : daySallary * (totalWorking() / 25200);

  const totalGajiProbation =
    data.employeeType === "Permanent"
      ? data.type === "history_contract"
        ? 0
        : basicSallaryProbation
      : daySallaryProbation
      ? daySallaryProbation * (totalWorkingProbation() / 25200)
      : 0;

  const totalGajiSetengahHari = (daySallary / 7) * halfDaySallary;

  const totalUangShiftSatu =
    data.type === "history_permanent" ? 0 : shiftOne * 4000;
  const totalLemburLibur =
    data.type === "history_permanent" ? 0 : daySallary * 2 * lemburLibur;

  const totalLemburLiburProbation =
    data.type === "history_permanent"
      ? 0
      : daySallaryProbation && lemburLiburProbation
      ? daySallaryProbation * 2 * lemburLiburProbation
      : 0;

  let checkTotalGajiProbation = totalGajiProbation ? totalGajiProbation : 0;

  const totalOvertime = (daySallary / 7) * lembur;
  const totalOTLibur = jamOTLibur * (daySallary / 7) * 2;
  const totalSebelumPotongan =
    totalGaji +
    checkTotalGajiProbation +
    totalGajiSetengahHari +
    totalUangShiftSatu +
    totalLemburLibur +
    totalLemburLiburProbation +
    totalOvertime +
    totalOTLibur +
    uangTransport() +
    uangMakan() +
    kurangBayar -
    lebihBayar -
    kasbon -
    potonganTidakMasuk;
  const takeHomePay = totalSebelumPotongan - bpjsTK() - bpjsK();

  return (
    <>
      <tr
        style={{ cursor: "pointer" }}
        onClick={() => setInitialExpand(!initialExpand)}
      >
        <div style={{ padding: "12px" }}>{index + 1}.</div>
        <td>{data.name}</td>
        <td>{data.position}</td>
        <td>{data.employeeType}</td>
      </tr>
      {initialExpand !== true ? (
        ""
      ) : (
        <>
          <tr>
            <td className="td-padding-top-8" style={{ border: "none" }}></td>
            <td className="top_left td-padding-top-8">Gaji</td>
            <td className="border_top td-padding-top-8">
              {data.employeeType === "Permanent" ? (
                <>Rp {formatDot(basicSallary)}</>
              ) : (
                <>
                  {Math.round((totalWorking() / 25200) * 100) / 100} Hari X
                  Rp&nbsp;
                  {formatDot(Math.round(daySallary))}
                </>
              )}
            </td>
            <td className="top_right td-padding-top-8">
              =&nbsp;&nbsp;
              <span style={{ color: "#3ebd81" }}>
                Rp {formatDot(Math.round(totalGaji))}
              </span>
            </td>
          </tr>
          <tr>
            <td className="td-padding-top-8" style={{ border: "none" }}></td>
            <td className="border_left td-padding-top-8">Gaji Setengah Hari</td>
            <td className="fontsize-14-td-payroll td-padding-top-8">
              {halfDaySallary < 0
                ? halfDaySallary.toFixed(1) * -1
                : halfDaySallary.toFixed(1)}{" "}
              Jam X Rp {formatDot(Math.round(daySallary / 7))}
            </td>
            <td className="border_right td-padding-top-8">
              =&nbsp;&nbsp;
              <span
                style={
                  halfDaySallary < 0 ? { color: "red" } : { color: "#3ebd81" }
                }
              >
                Rp{" "}
                {halfDaySallary < 0
                  ? formatDot(Math.round(totalGajiSetengahHari * -1))
                  : formatDot(Math.round(totalGajiSetengahHari))}
              </span>
            </td>
          </tr>
          <tr style={{ color: "#F4991A" }}>
            <td className="td-padding-top-8" style={{ border: "none" }}></td>
            <td className="border_left td-padding-top-8">Gaji Probation</td>
            <td className="fontsize-14-td-payroll td-padding-top-8">
              {data.employeeType === "Permanent" ? (
                <>
                  Rp {daySallaryProbation ? formatDot(daySallaryProbation) : 0}
                </>
              ) : (
                <>
                  {totalWorkingProbation()
                    ? Math.round((totalWorkingProbation() / 25200) * 100) / 100
                    : 0}{" "}
                  Hari X Rp&nbsp;
                  {daySallaryProbation
                    ? formatDot(Math.round(daySallaryProbation))
                    : 0}
                </>
              )}
            </td>
            <td className="border_right td-padding-top-8">
              =&nbsp;&nbsp;
              <span style={{ color: "#3ebd81" }}>
                Rp {formatDot(Math.round(checkTotalGajiProbation))}
              </span>
            </td>
          </tr>
          <tr>
            <td className="td-padding-top-8" style={{ border: "none" }}></td>
            <td className="border_left td-padding-top-8">Uang Shift 1</td>
            <td className="fontsize-14-td-payroll td-padding-top-8">
              {shiftOne} Hari X Rp 4.000
            </td>
            <td className="border_right td-padding-top-8">
              =&nbsp;&nbsp;
              <span style={{ color: "#3ebd81" }}>
                Rp {formatDot(totalUangShiftSatu)}
              </span>
            </td>
          </tr>
          <tr>
            <td className="td-padding-top-8" style={{ border: "none" }}></td>
            <td className="border_left td-padding-top-8">Lembur Libur</td>
            <td className="fontsize-14-td-payroll td-padding-top-8">
              {lemburLibur} Hari X Rp {formatDot(Math.round(daySallary * 2))}
            </td>
            <td className="border_right td-padding-top-8">
              =&nbsp;&nbsp;
              <span style={{ color: "#3ebd81" }}>
                Rp {formatDot(Math.round(totalLemburLibur))}
              </span>
            </td>
          </tr>
          <tr style={{ color: "#F4991A" }}>
            <td className="td-padding-top-8" style={{ border: "none" }}></td>
            <td className="border_left td-padding-top-8">
              Lembur Libur Probation
            </td>
            <td className="fontsize-14-td-payroll td-padding-top-8">
              {lemburLiburProbation ? lemburLiburProbation : 0} Hari X Rp{" "}
              {daySallaryProbation
                ? formatDot(Math.round(daySallaryProbation * 2))
                : 0}
            </td>
            <td className="border_right td-padding-top-8">
              =&nbsp;&nbsp;
              <span style={{ color: "#3ebd81" }}>
                Rp {formatDot(Math.round(totalLemburLiburProbation))}
              </span>
            </td>
          </tr>
          <tr>
            <td className="td-padding-top-8" style={{ border: "none" }}></td>
            <td className="border_left td-padding-top-8">Lebih Waktu</td>
            <td className="fontsize-14-td-payroll td-padding-top-8">
              {displayJamOT} Jam ({data && data.totalOT} Rumus) X Rp{" "}
              {formatDot(Math.round(daySallary / 7))}
            </td>
            <td className="border_right td-padding-top-8">
              =&nbsp;&nbsp;
              <span style={{ color: "#3ebd81" }}>
                Rp {formatDot(Math.round(totalOvertime))}
              </span>
            </td>
          </tr>
          <tr>
            <td className="td-padding-top-8" style={{ border: "none" }}></td>
            <td className="border_left td-padding-top-8">Lembur Waktu Libur</td>
            <td className="fontsize-14-td-payroll td-padding-top-8">
              {jamOTLibur} Jam X Rp{" "}
              {formatDot(Math.round((daySallary / 7) * 2))}
            </td>
            <td className="border_right td-padding-top-8">
              =&nbsp;&nbsp;
              <span style={{ color: "#3ebd81" }}>
                Rp {formatDot(Math.round(totalOTLibur))}
              </span>
            </td>
          </tr>
          <tr>
            <td className="td-padding-top-8" style={{ border: "none" }}></td>
            <td className="border_left td-padding-top-8">Uang Transport</td>
            <td></td>
            <td className="border_right td-padding-top-8">
              =&nbsp;&nbsp;
              <span style={{ color: "#3ebd81" }}>
                Rp {formatDot(uangTransport())}
              </span>
            </td>
          </tr>
          <tr>
            <td className="td-padding-top-8" style={{ border: "none" }}></td>
            <td className="border_left td-padding-top-8">Uang Makan</td>
            <td className="td-padding-top-8"></td>
            <td className="border_right td-padding-top-8">
              =&nbsp;&nbsp;
              <span style={{ color: "#3ebd81" }}>
                Rp {formatDot(uangMakan())}
              </span>
            </td>
          </tr>
          <tr>
            <td className="td-padding-top-8" style={{ border: "none" }}></td>
            <td className="border_left td-padding-top-8">
              Kurang Bayar (
              {data.keteranganKurangBayar ? data.keteranganKurangBayar : ""})
            </td>
            <td className="td-padding-top-8"></td>
            <td className="border_right td-padding-top-8">
              =&nbsp;&nbsp;
              <span style={{ color: "#3ebd81" }}>
                Rp {formatDot(Math.round(kurangBayar))}
              </span>
            </td>
          </tr>
          <tr>
            <td className="td-padding-top-8" style={{ border: "none" }}></td>
            <td className="border_left td-padding-top-8">
              Lebih Bayar (
              {data.keteranganLebihBayar ? data.keteranganLebihBayar : ""})
            </td>
            <td className="td-padding-top-8"></td>
            <td className="border_right td-padding-top-8">
              =&nbsp;&nbsp;
              <span style={{ color: "red" }}>
                Rp {formatDot(Math.round(lebihBayar))}
              </span>
            </td>
          </tr>
          <tr>
            <td className="td-padding-top-8" style={{ border: "none" }}></td>
            <td className="border_left td-padding-top-8">Tidak Masuk (Hari)</td>
            <td className="fontsize-14-td-payroll td-padding-top-8">
              {(tidakMasuk / 7).toFixed(1)} Hari X Rp{" "}
              {formatDot(Math.round(daySallary))}
            </td>
            <td className="border_right td-padding-top-8">
              =&nbsp;&nbsp;
              <span style={{ color: "red" }}>
                Rp {formatDot(Math.round(potonganTidakMasuk))}
              </span>
            </td>
          </tr>
          <tr>
            <td className="td-padding-top-8" style={{ border: "none" }}></td>
            <td className="border_top border_left td-padding-top-8">Total</td>
            <td className="border_top td-padding-top-8"></td>
            <td className="border_top border_right td-padding-top-8">
              =&nbsp;&nbsp;
              <span style={{ color: "#3ebd81" }}>
                Rp {formatDot(Math.round(totalSebelumPotongan))}
              </span>
            </td>
          </tr>
          <tr>
            <td className="td-padding-top-8" style={{ border: "none" }}></td>
            <td className="border_left td-padding-top-8">Potongan</td>
            <td className="td-padding-top-8"></td>
            <td className="border_right td-padding-top-8"></td>
          </tr>
          <tr>
            <td className="td-padding-top-8" style={{ border: "none" }}></td>
            <td className="border_left td-padding-top-8">
              &nbsp;&nbsp;BPJSTK ({bulanBayar()})
            </td>
            <td className="td-padding-top-8"></td>
            <td className="border_right td-padding-top-8">
              =&nbsp;&nbsp;
              <span style={{ color: "red" }}>Rp {formatDot(bpjsTK())}</span>
            </td>
          </tr>
          <tr>
            <td className="td-padding-top-8" style={{ border: "none" }}></td>
            <td className="border_left td-padding-top-8">
              &nbsp;&nbsp;BPJSK ({bulanBayar()})
            </td>
            <td className="td-padding-top-8"></td>
            <td className="border_right td-padding-top-8">
              =&nbsp;&nbsp;
              <span style={{ color: "red" }}>Rp {formatDot(bpjsK())}</span>
            </td>
          </tr>
          <tr>
            <td className="td-padding-top-8" style={{ border: "none" }}></td>
            <td className="bottom_left border_top td-padding-top-8">
              Jumlah Yang Diterima
            </td>
            <td className="border_bottom border_top td-padding-top-8"></td>
            <td className="bottom_right border_top td-padding-top-8">
              =&nbsp;&nbsp;
              <span style={{ color: "#3ebd81" }}>
                Rp {formatDot(Math.round(takeHomePay))}
              </span>
            </td>
          </tr>
        </>
      )}
    </>
  );
};
export default Accordion;
